import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";

// ------------------------
//  Aisea 用 Firebase
// ------------------------
// 中身は Firebase Web SDK の設定値(apiKey / authDomain / projectId など)。
// ブラウザに配信される公開値であって、サービスアカウント鍵ではない。
// 実体はリポジトリ直下に CI か npm run env:<環境> が書き出す(gitignore 済み)
const firebaseConfig = require("../../firebase-web-config.json");
firebase.initializeApp({ ...firebaseConfig });
const db = firebase.firestore();
const storage = firebase.storage().ref();
const storageWebCam = firebase
  .storage()
  .refFromURL(String(process.env.VUE_APP_FIRESOTRAGE_WEBCAM_BUCKET_URL));
const storageMediamtx = firebase
  .storage()
  .refFromURL("gs://aisea-movie-stream");
const storageDocuments = firebase
  .storage()
  .refFromURL(String(process.env.VUE_APP_FIRESOTRAGE_DOCUMENTS_BUCKET_URL));
const storagePrefixUrl = String(
  process.env.VUE_APP_FIRESOTRAGE_DOCUMENTS_PREFIX_URL
);

// ------------------------
// RadarGrid 用 Firebase
// ------------------------
// 環境変数は RADAR_GRID 系のみを使用（旧プレフィックスは廃止）。未設定は本番既定値でフォールバック。
const radarGridFirebaseConfig = {
  apiKey: process.env.VUE_APP_RADAR_GRID_API_KEY || "",
  authDomain: process.env.VUE_APP_RADAR_GRID_AUTH_DOMAIN || "",
  databaseURL: process.env.VUE_APP_RADAR_GRID_DATABASE_URL || "",
  projectId: process.env.VUE_APP_RADAR_GRID_PROJECT_ID || "",
  storageBucket: process.env.VUE_APP_RADAR_GRID_STORAGE_BUCKET || "",
  messagingSenderId: process.env.VUE_APP_RADAR_GRID_MESSAGING_SENDER_ID || "",
  appId: process.env.VUE_APP_RADAR_GRID_APP_ID || "",
  measurementId: process.env.VUE_APP_RADAR_GRID_MEASUREMENT_ID || "",
};

// すでに radarGridApp が存在しているか確認してから初期化
const radarGridApp = firebase.initializeApp(
  radarGridFirebaseConfig,
  "radarGrid"
);

// RadarGrid 用 Firestore と Storage
const radarGridStorageRef = radarGridApp.storage().ref();

export {
  db,
  firebase,
  storage,
  storageWebCam,
  storageMediamtx,
  firebaseConfig,
  storageDocuments,
  storagePrefixUrl,
  radarGridApp,
  radarGridStorageRef,
};
